export const environment = {
  featureFlags: { driverSession: false },
  production: false,
  chatbotFeatureFlag: true,
  manualBlockTimeEntryFeatureFlag: true,
  layerSettings: {
    'boundary': { 
      filterByExtent: false 
    },
    'roads': { 
      minScale: 30000,
      filterByExtent: true,
      popup: {
        includeFields: ['RoadId', 'Name', 'MaintOwner', 'CollectionAllowed']
      }
    }
  } as Record<string, { minScale?: number; filterByExtent?: boolean; popup?: { includeFields?: string[]; excludeFields?: string[] } }>,
  esri: {
    apiKey: 'AAPKfb21386f7ec0403f91e79c8ea0216881KYN7Sz3khZf2zspAxq8Hho06gYI_ZIxSHw3rlRGHyv-fapE73eb-uVHbigZa5riZ',
  },
  appShellConfig: {
    debug: false,
    networkDelay: 500,
  },
  applicationInsightsConnectionString: 'InstrumentationKey=d9ab2d02-46e6-4ca5-b70e-7df91fd1c26e;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=c38b916a-74b4-4a09-a562-bd502c8d66e0',
  legacyApiUrl: 'https://func-rt-dev-centralus-01.azurewebsites.net/api',
  authApiUrl: ( 
      process.env['NG_APP_AuthService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/auth'
  ) + "/api",
  activityApiUrl: (
      process.env['NG_APP_ActivityService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/activity'
  ) + "/api",
  auditApiUrl: (
      process.env['NG_APP_AuditService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/audit'
  ) + "/api",
  projectApiUrl: (
      process.env['NG_APP_ProjectService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/project'
  ) + "/api",
  userApiUrl: (
      process.env['NG_APP_UserService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/user'
  ) + "/api",
  lookupApiUrl: (
      process.env['NG_APP_LookupService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/lookup'
  ) + "/api",
  timeRecordApiUrl: (
      process.env['NG_APP_TimeRecordService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/timerecord'
  ) + "/api",
  timeApiUrl: (
      process.env['NG_APP_TimeService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/time'
  ) + "/api",
  mobileApiUrl: (
      process.env['NG_APP_MobileService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/mobile'
  ) + "/api",
  attachmentApiUrl: ( 
      process.env['NG_APP_AttachmentService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/attachment'
  ) + "/api",
  rolesApiUrl: (
      process.env['NG_APP_RoleService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/role'
  ) + "/api",
  flexFormsApiUrl: (
      process.env['NG_APP_FormService'] ??
      'https://apim-rtsvc-test-centralus.azure-api.net/form'
  ) + "/api",
  notificationApiUrl: (
      process.env['NG_APP_NotificationService'] ??
      'https://app-rtsvc-notification-test-centralus.azurewebsites.net'
  ) + "/api",
  webApiBaseUrl: (
    process.env['NG_APP_WebApi'] ??
    "https://app-rtsvc-webapi-test-centralus.azurewebsites.net"
  ) + "/api",
  authApiKey: 'eEy1WT6vVV5PVlCVUc0wFhSnFuHfhDt8',
  apimSubscriptionKey: 'fd3ea35c34ae4f92990ef27df3a2e02c',
  fakeGPS: {
    useFakeGPS: false,
    latitude: 40.714224,
    longitude: -73.961452,
  },
  version: '4.10.5',
  pollingTimeMs: 300000,
  sharedFormQrCodeEncryptionKey: 'YDKGM',
  receiptQrCodeEncryptionKey: 'EJQDXPIU',
  storageEncryptionKey: 'RT_Flex_LS_2024',
  jwtIssuer: process.env['NG_APP_Authorization__Issuance__Issuer'] ?? 'urn:recoverytrac:issuance:driver-session',
  jwtAudience: process.env['NG_APP_Authorization__Issuance__Audience'] ?? 'RecoveryTrac.API',
  defaultLoggingLevel: 3, // INFO
};
